import $ from 'jquery';
import 'jquery-mask-plugin';

export function inputMasks() {
  $('.date').mask('00/00/0000');
  $('.cep').mask('00000-000');
  $('.real').mask('000.000.000,00', { reverse: true });
  
  var SPMaskBehavior = function (val) {
    return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
  };
  
  var spOptions = {
    onKeyPress: function(val, e, field, options) {
      field.mask(SPMaskBehavior.apply({}, arguments), options);
    }
  };
  
  $('.sp_celphones').mask(SPMaskBehavior, spOptions);
}